import { AfterViewInit, Directive, ElementRef, Input, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[data-lokalise]',
})
export class LokaliseDirective implements AfterViewInit {
  @Input('data-key') key: string;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    private readonly translate: TranslateService,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.renderer;
  }

  ngAfterViewInit() {
    if (this.key) {
      this.translate
        .get(this.key)
        .pipe(take(1))
        .subscribe(translation => {
          const sanitizedTranslation = this.sanitizer.sanitize(SecurityContext.HTML, translation);
          this.renderer.setProperty(this.el.nativeElement, 'innerHTML', sanitizedTranslation);
        });
    }
  }
}
